// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Styles$GameDataCore from "./Styles.res.mjs";

function px(value) {
  return value.toString() + "px";
}

function orEmpty(value) {
  if (value !== undefined) {
    return value;
  } else {
    return "";
  }
}

function verticalRangesOverlap(aTop, aHeight, bTop, bBottom) {
  var aBottom = aTop + aHeight;
  if (aBottom > bTop) {
    return aTop < bBottom;
  } else {
    return false;
  }
}

function bottomOf(id) {
  var element = document.getElementById(id);
  if (element == null) {
    return 0.0;
  } else {
    return element.getBoundingClientRect().bottom;
  }
}

function getMenuOffsets(container, trigger, menu, updateSize) {
  var padding = Styles$GameDataCore.getSpacingSize() * 5.0;
  var headerBottom = Math.max(bottomOf("account-bar"), bottomOf("page-header"));
  var menuStyle = menu.style;
  menuStyle.maxHeight = "";
  var triggerRect = trigger.getBoundingClientRect();
  var viewportWidth = window.innerWidth;
  var vw = Math.max(0.0, viewportWidth - 2.0 * padding);
  var targetWidth = Math.min(Math.max(triggerRect.width, 240.0), vw);
  var width = targetWidth.toString() + "px";
  updateSize(width);
  var menuRect = menu.getBoundingClientRect();
  var minTopViewport = Math.max(padding, headerBottom + padding);
  var bottomLimit = window.innerHeight - padding;
  var availableBelow = Math.max(0.0, bottomLimit - triggerRect.bottom - 4.0);
  var availableAbove = Math.max(0.0, triggerRect.top - minTopViewport - 4.0);
  var left;
  var top;
  var match = container.getAttribute("data-position-x");
  if (!(match == null)) {
    switch (match) {
      case "center" :
          left = triggerRect.left + menuRect.width > viewportWidth ? (viewportWidth - menuRect.width).toString() + "px" : (triggerRect.left - menuRect.width * 0.5 + triggerRect.width * 0.5).toString() + "px";
          break;
      case "left" :
          left = triggerRect.left + menuRect.width + padding > viewportWidth ? (
              menuRect.width > triggerRect.width && triggerRect.left - (menuRect.width - triggerRect.width) < padding ? triggerRect.left.toString() + "px" : (viewportWidth - menuRect.width - padding).toString() + "px"
            ) : triggerRect.left.toString() + "px";
          break;
      case "right" :
          left = (triggerRect.right - menuRect.width).toString() + "px";
          break;
      default:
        
    }
  }
  var match$1 = container.getAttribute("data-position-y");
  var exit = 0;
  if ((match$1 == null) || match$1 !== "above") {
    exit = 1;
  } else {
    var desiredTop = triggerRect.top - menuRect.height;
    if (desiredTop >= minTopViewport) {
      top = desiredTop.toString() + "px";
    } else if (availableAbove >= 48.0) {
      menuStyle.maxHeight = availableAbove.toString() + "px";
      menuRect = menu.getBoundingClientRect();
      top = (triggerRect.top - menuRect.height).toString() + "px";
    } else {
      top = triggerRect.bottom.toString() + "px";
      if (menuRect.height > availableBelow) {
        var value = Math.max(48.0, availableBelow);
        menuStyle.maxHeight = value.toString() + "px";
        menuRect = menu.getBoundingClientRect();
      }
      
    }
  }
  if (exit === 1) {
    if (availableBelow >= 48.0) {
      top = triggerRect.bottom.toString() + "px";
      if (menuRect.height > availableBelow) {
        menuStyle.maxHeight = availableBelow.toString() + "px";
        menuRect = menu.getBoundingClientRect();
      }
      
    } else if (availableAbove >= 48.0) {
      var value$1 = Math.min(menuRect.height, availableAbove);
      menuStyle.maxHeight = value$1.toString() + "px";
      menuRect = menu.getBoundingClientRect();
      top = (triggerRect.top - menuRect.height).toString() + "px";
    } else {
      top = triggerRect.bottom.toString() + "px";
      var value$2 = Math.max(24.0, availableBelow);
      menuStyle.maxHeight = value$2.toString() + "px";
      menuRect = menu.getBoundingClientRect();
    }
  }
  var value$3 = left;
  var leftNum = parseFloat(value$3 !== undefined ? value$3 : "0");
  if (Number.isFinite(leftNum)) {
    var maxLeft = Math.max(padding, viewportWidth - menuRect.width - padding);
    var value$4 = Math.min(Math.max(leftNum, padding), maxLeft);
    left = value$4.toString() + "px";
  }
  var value$5 = top;
  var topNum = parseFloat(value$5 !== undefined ? value$5 : "0");
  if (Number.isFinite(topNum) && verticalRangesOverlap(topNum, menuRect.height, triggerRect.top, triggerRect.bottom)) {
    var fitsBelow = triggerRect.bottom + menuRect.height <= bottomLimit;
    if (fitsBelow) {
      top = triggerRect.bottom.toString() + "px";
      menuStyle.maxHeight = "";
      menuRect = menu.getBoundingClientRect();
      if (menuRect.height > availableBelow) {
        menuStyle.maxHeight = availableBelow.toString() + "px";
        menuRect = menu.getBoundingClientRect();
      }
      
    } else {
      var aboveTop = triggerRect.top - menuRect.height;
      if (aboveTop >= minTopViewport) {
        top = aboveTop.toString() + "px";
        menuStyle.maxHeight = "";
        menuRect = menu.getBoundingClientRect();
      } else if (availableBelow >= availableAbove && availableBelow > 48.0) {
        menuStyle.maxHeight = availableBelow.toString() + "px";
        menuRect = menu.getBoundingClientRect();
        top = triggerRect.bottom.toString() + "px";
      } else if (availableAbove > 48.0) {
        menuStyle.maxHeight = availableAbove.toString() + "px";
        menuRect = menu.getBoundingClientRect();
        var value$6 = Math.max(triggerRect.top - menuRect.height, minTopViewport);
        top = value$6.toString() + "px";
      } else {
        var value$7 = Math.max(48.0, availableBelow);
        menuStyle.maxHeight = value$7.toString() + "px";
        menuRect = menu.getBoundingClientRect();
        top = triggerRect.bottom.toString() + "px";
      }
    }
    var value$8 = top;
    topNum = parseFloat(value$8 !== undefined ? value$8 : "0");
    if (Number.isFinite(topNum)) {
      var overflowBottom = topNum + menuRect.height - (bottomLimit - 4.0);
      if (overflowBottom > 0.0) {
        var cap = Math.max(48.0, menuRect.height - overflowBottom);
        menuStyle.maxHeight = cap.toString() + "px";
        menuRect = menu.getBoundingClientRect();
      }
      
    }
    
  }
  var appliedMaxHeight = menuStyle.maxHeight;
  return {
          top: top,
          left: left,
          width: width,
          maxHeight: appliedMaxHeight === "" ? undefined : appliedMaxHeight
        };
}

export {
  px ,
  orEmpty ,
  verticalRangesOverlap ,
  bottomOf ,
  getMenuOffsets ,
}
/* No side effect */
